import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        countries: '=',
        directManagers: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.Add user' | translate }}</h1>
        </div>
        <form role="form" ng-submit="vm.save()">
            <div class="person01">
                <div class="txt">
                    <form-wrapper form="vm.form">
                        <form-row error="vm.form.errors.siteIds">
                            <label class="label">
                                {{ 'user.Site' | translate }} *<br>
                                <small>{{ 'user.In which site the employee works at' | translate }}</small>
                            </label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.sites.options"
                                    selected-model="vm.sites.models"
                                    extra-settings="vm.sites.settings"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.isDirectManager" ng-if="vm.PrivilegeService.isCompanyAdmin()">
                            <span class="label">{{ 'user.Direct manager' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.isDirectManager" ng-value="true">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.hasAllLearnersReportViewPrivilege"
                         ng-if="vm.PrivilegeService.isCompanyAdmin() && vm.form.model.isDirectManager">
                            <span class="label">{{ 'user.Allow to monitor learner progress for all site users' | translate }}
                                <span class="tooltip-icon"
                                    uib-tooltip="{{ 'user.Monitor learner progress for all site tooltip' | translate }}"
                                    tooltip-placement="top-right">?</span>
                           </span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.hasAllLearnersReportViewPrivilege" ng-value="true">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.hasMyEmployeeManagePrivilege"
                         ng-if="vm.PrivilegeService.isCompanyAdmin() && vm.form.model.isDirectManager">
                            <span class="label">{{ 'user.Can add employees' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.hasMyEmployeeManagePrivilege" ng-value="true">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.isTrainer" ng-if="vm.PrivilegeService.isCompanyAdmin()">
                            <span class="label">{{ 'user.Trainer' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.isTrainer" ng-value="true">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.isManager" ng-if="vm.PrivilegeService.isCompanyAdmin()">
                            <span class="label">{{ 'user.Company manager' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.isManager" ng-change="vm.confirmPromotingToManager()" ng-value="true">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <p class="desc" ng-if="vm.form.model.isManager">
                                    {{ 'general.User add company manager explanation' | translate }}
                                </p>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <hr/>
                        <form-row error="vm.form.errors.firstName">
                            <label class="label">{{ 'user.First name' | translate }} *</label>
                            <div class="items">
                                <input ng-model="vm.form.model.firstName" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.lastName">
                            <label class="label">{{ 'user.Last name' | translate }} *</label>
                            <div class="items">
                                <input ng-model="vm.form.model.lastName" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.country">
                            <label class="label">{{ 'user.Country' | translate }} *</label>
                            <div class="items">
                                <ui-select ng-model="vm.form.model.country" theme="selectize" title="{{ 'user.Country' | translate }}">
                                    <ui-select-match placeholder="{{ 'user.Select or search a country in the list...' | translate }}"
                                    >{{$select.selected.label}}</ui-select-match>
                                    <ui-select-choices repeat="country.key as country in vm.countries | filter: $select.search">
                                        <span ng-bind-html="country.label | highlight: $select.search"></span>
                                    </ui-select-choices>
                                </ui-select>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.coursyLanguage">
                          <label class="label">{{ 'user.Language' | translate }} *</label>
                          <div class="items">
                            <select class="form-control"
                                    ng-model="vm.form.model.coursyLanguage"
                                    ng-options="code as language
                                                for (code, language) in vm.COMPANY_LANGUAGE_ENUM.LABELS
                                                track by code">
                            </select>
                            <form-row-error></form-row-error>
                          </div>
                        </form-row>
                        <form-row error="vm.form.errors.timezone">
                            <label class="label">{{ 'user.Timezone' | translate }} *</label>
                                <div class="items">
                                    <form-row-error></form-row-error>
                                    <select class="form-control" ng-model="vm.form.model.timezone">
                                        <option
                                            ng-repeat="(timezone, label) in vm.TIMEZONE_ENUM.LABELS"
                                            value="{{ vm.TIMEZONE_ENUM.KEYS[timezone] }}">
                                            {{ label }}
                                        </option>
                                    </select>
                                </div>
                        </form-row>
                        <form-row error="vm.form.errors.idCode">
                            <label class="label">{{ 'user.Personal code' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.idCode" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.primaryEmail">
                            <label class="label">{{ 'user.Email' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.primaryEmail" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.contactPhone">
                            <label class="label">{{ 'user.Phone' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.contactPhone" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </form-wrapper>
                </div>
            </div>
            <div class="well color03 form">
                <h2>{{ 'user.Career related' | translate }}</h2>
                <div class="form">
                    <form-row error="vm.form.errors.drls" ng-if="vm.lodash.isString(vm.form.errors.drls)">
                        <form-row-error></form-row-error>
                    </form-row>
                </div>
                <form-row error="vm.form.errors.drls[0].departmentId">
                    <label class="label">{{ 'user.Department' | translate }} *</label>
                    <div class="items">
                        <select
                            class="form-control"
                            ng-model="vm.form.model.drls[0].departmentId"
                            ng-options="department.id as department.value for department in vm.departments"
                        />
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.drls[0].roleId">
                    <label class="label">{{ 'user.Role' | translate }} *</label>
                    <div class="items">
                        <select
                            class="form-control"
                            ng-model="vm.form.model.drls[0].roleId"
                            ng-options="role.id as role.value for role in vm.roles"
                        />
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.drls[0].levelId">
                    <label class="label">{{ 'user.Level' | translate }} *</label>
                    <div class="items">
                        <select
                            class="form-control"
                            ng-model="vm.form.model.drls[0].levelId"
                            ng-options="level.id as level.value for level in vm.levels"
                        />
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.directManagerIds">
                    <label class="label">{{ 'user.Employees direct manager' | translate }}</label>
                    <div class="items">
                        <tags-input
                            key-property="id"
                            display-property="displayName"
                            add-from-autocomplete-only="true"
                            replace-spaces-with-dashes="false"
                            ng-model="vm.chosenManagers"
                            placeholder="{{ 'user.Add direct manager' | translate }}">
                            <auto-complete min-length="1" source="vm.filterManagers($query)"></auto-complete>
                        </tags-input>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.workingSince">
                    <label class="label">{{ 'user.Working since' | translate }} *</label>
                    <div class="items">
                        <datepicker-api ng-model="vm.form.model.workingSince"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row>
                    <label class="label"></label>
                    <div class="items">
                        <ul class="checkboxes w100p c-both">
                            <li><label><input type="checkbox" ng-model="vm.form.model.suspended"> {{ 'user.Add inactivity period' | translate }}</label></li>
                        </ul>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.suspended == true" error="vm.form.errors.start">
                    <label class="label">{{ 'user.Inactive from' | translate }}</label>
                    <div class="items">
                        <datepicker-api ng-model="vm.form.model.inactivityPeriods[0].start"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.suspended == true" error="vm.form.errors.end">
                    <label class="label">{{ 'user.Inactive to' | translate }}</label>
                    <div class="items">
                        <datepicker-api ng-model="vm.form.model.inactivityPeriods[0].end"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.suspended == true" error="vm.form.errors.description">
                    <label class="label">{{ 'user.Inactivity description' | translate }}</label>
                    <div class="items">
                        <textarea ng-model="vm.form.model.inactivityPeriods[0].description" class="form-control"></textarea>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <div class="well color02">
                    <h2>{{ 'user.Extra actions' | translate }}</h2>
                    <form-row error="vm.form.errors.sendPortalActivationMessage">
                        <ul class="checkboxes">
                            <li>
                                <label>
                                    <input ng-model="vm.form.model.sendPortalActivationMessage" type="checkbox">
                                    <span>{{ 'user.Send employee portal account activation e-mail' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </li>
                        </ul>
                    </form-row>
                </div>
            </div>
            <ul class="actions01">
                <li class="primary"><a ng-click="vm.save()" class="btn main">{{ 'general.Add' | translate }}</a></li>
                <li><a ui-sref="authorized.user.employee.list()" class="btn discrete" >{{ 'general.Cancel' | translate }}</a></li>
            </ul>
            <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
        </form>
    `
})
export default class {
    constructor ($state, $translate, lodash, toastr, FormFactory,
                 TokenService, PrivilegeService, SiteService, ModalService, FilterService,
                 ROLE_PRIVILEGE_ENUM, USER_CUSTOM_ERROR_ENUM, COMPANY_LANGUAGE_ENUM, TIMEZONE_ENUM) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.form = FormFactory.createFromResource(this.user);
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.ModalService = ModalService;
        this.FilterService = FilterService;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.USER_CUSTOM_ERROR_ENUM = USER_CUSTOM_ERROR_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.TIMEZONE_ENUM = TIMEZONE_ENUM;
    }

    $onInit () {
        this.chosenManagers = [];
        this.initMultiSelect();
        this.form.model.coursyLanguage = this.TokenService.getCompanyLanguage();
        this.form.model.timezone = this.TokenService.getCompanyTimezone();
        this.filterTranslations = this.FilterService.getTranslations();
    }

    beforeSave () {
        this.form.model.directManagerIds = this.chosenManagers.map(manager => manager.id);
        this.form.model.siteIds = this.sites.models.map(site => site.value);
    }

    save (validateNotifications = true) {
        this.beforeSave();
        if (this.form.model.sendPortalActivationMessage) {
            const message = this.$translate.instant('user.confirm_sending_activation_message');
            this.ModalService.confirm(message, 'medium')
                .then(() => this.doSave(validateNotifications))
            ;
        }
        else {
            this.doSave(validateNotifications);
        }
    }

    doSave (validateNotifications) {
        const additionalGetParams = validateNotifications ? { validateNotifications: true } : { validateNotifications: null };
        this.form.save(additionalGetParams)
            .then((model) => {
                this.toastr.success(this.$translate.instant('user.New user added', { name: model.displayName }));
                this.$state.go('authorized.user.employee.detail', { id: model.id });
            }).catch((response) => {
                if (this.lodash.isEmpty(response.data) || !Array.isArray(response.data)) {
                    return;
                }

                let hasOnlyNotifications = true;
                // if we have any other than CUSTOM_ERROR
                response.data.forEach((error) => {
                    if (!this.USER_CUSTOM_ERROR_ENUM.KEYS[error.field]) {
                        hasOnlyNotifications = false;
                    }
                });

                if (!hasOnlyNotifications) {
                    return;
                }

                const addConfirmMessage = this.$translate.instant('user.name_already_exist_notification');
                this.form.errors = {};
                this.form.invalid = false;
                this.ModalService.confirm(addConfirmMessage, 'medium').then(() => this.save(false));
            })
        ;
    }

    filterManagers (value) {
        return this.directManagers.filter((field) => this.lodash.includes(field.displayName.toUpperCase(), value.toUpperCase()));
    }

    initMultiSelect () {
        const siteOptions = this.getSiteOptions();
        const selectedOptions = this.getSelectedSiteOptions(siteOptions);

        this.sites = {
            models: selectedOptions,
            options: siteOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                smartButtonMaxItems: 5,
                smartButtonTextConverter: (itemText) => itemText
            }
        };
    }

    /**
     * Selected options have to be composed of siteOptions objects
     * they have to be references of each-other for multiselect to work
     * @param siteOptions
     * @returns {[]}
     */
    getSelectedSiteOptions (siteOptions) {
        const selectedSiteIds = [this.TokenService.getActiveSiteId()];
        return siteOptions.filter(option => this.lodash.includes(selectedSiteIds, option.value));
    }

    getSiteOptions () {
        let siteOptions = [];
        const cb = site => {
            return {
                value: site.id,
                label: site.name
            };
        };
        const sites = this.SiteService.getSitesByPrivileges([this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE]);
        siteOptions = sites.map(site => cb(site));
        return siteOptions;
    }

    confirmPromotingToManager () {
        if (this.form.model.isManager) {
            const message = this.$translate.instant('user.Confirm promoting to manager message.');
            this.ModalService.confirm(message).catch(() => {
                this.form.model.isManager = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/add/index.js